class AudioRecorderService {
  constructor() {
    this.mediaRecorder = null;
    this.audioChunks = [];
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }

  async startRecording() {
    if (!this.audioContext) return;

    await this.audioContext.resume();
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const audioConstraints = isMobile
          ? { audio: { echoCancellation: false, noiseSuppression: false } }
          : { audio: true };
        const stream = await navigator.mediaDevices.getUserMedia(audioConstraints);
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks = [];
        this.mediaRecorder.start();

        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };
      } catch (err) {
        console.error('Error starting audio recording:', err);
      }
    } else {
      alert('Audio recording is not supported in this browser.');
    }
  }

  stopRecording() {
    return new Promise((resolve, reject) => {
      if (this.mediaRecorder) {
        this.mediaRecorder.stop();

        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
          this.audioChunks = [];
          resolve(audioBlob);
        };

        this.mediaRecorder.onerror = (event) => {
          reject(event.error);
        };
      } else {
        reject(new Error('No media recorder available'));
      }
    });
  }
}

const audioRecorderService = new AudioRecorderService();
export default audioRecorderService;